"use client";

import React, {useEffect, useState} from "react";
import styles from "../UI/UI.module.css";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import {AiHelpManager} from "@/Core/AIHelp/AiHelpBox";
import {RecordFailState} from "@/Core/Redeem/redeemEnum";
import Util from "@/Master/Util";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";
import {confJson} from "@/app/config/confJson";

/**
 * 函数组件版 RedeemFailDialog 的 Props
 */
interface RedeemRecordFailDialogProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
    recordInfo:RedeemRecordInfo,
}

export const RedeemRecordFailDialogFC: React.FC<RedeemRecordFailDialogProps> = (props) => {
    const { fcKey, onClose,recordInfo } = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========

    const onBtnClick = () => {
        AiHelpManager.ShowContactUs();
    };

    const getFailMsg = () => {
        let failMsg:any = '';
        switch (recordInfo.failState) {
            case RecordFailState.None:
                failMsg = `Your order failed to be verified. Please contact customer service to handle your abnormal order. I wish you a happy life.`;
                break;
            case RecordFailState.Cancel:
                failMsg = 'Due to your cancellation of the redemption order, this withdrawal request has failed, and correlated funds have been refunded to your in-game balance. Please kindly check.';
                break;
            case RecordFailState.AutoReject:
                failMsg = `The ${RedeemUtil.getChannelName(recordInfo.channelType)} Account your input has been bound to another ${confJson.h5_app_name} account. One ${confJson.h5_app_name} Account can only be bound to one ${RedeemUtil.getChannelName(recordInfo.channelType)} account of withdrawal. We suggest you change to another account for withdrawal or log in to the ${confJson.h5_app_name} account that is bound to this {channel2=paypel} Account to continue. If you need any help, please feel free to contact us`;
                break;
            case RecordFailState.PeopleReject:
                failMsg = 'Your withdrawal request was canceled because of your fraud. All the funds will be forfeited and we may even freeze your account if it happens again. If you have any questions, please feel free to contact us.';
                break;
            case RecordFailState.PayFail:
                // failMsg = 'Your withdrawal request has been canceled because we failed to send the withdrawal to the account you provided. All the funds have returned to your account balance. Please check your account and resubmit your withdrawal require.';
                if (recordInfo.comment){
                    failMsg = recordInfo.comment;
                }else{
                    failMsg = `Your order failed to be verified. Please contact customer service to handle your abnormal order. I wish you a happy life.`;
                }
                break;
            case RecordFailState.ThirdPartyReject:
                failMsg = `According to ${RedeemUtil.getChannelName(recordInfo.channelType)} System, this withdrawal request has failed, and correlated funds have been refunded to your in-game balance. Please kindly check.`;
                break;
            case RecordFailState.LongLongAgo:
                failMsg = 'LongLongAgo';
                break;
            case RecordFailState.OrderFallback:
                failMsg = 'Due to some unexpected issues, your redemption has failed. Your sweepstakes coins have been returned to your balance. Please try again and we recommend using a different method. We sincerely apologize for any inconvenience caused.';
                break;

        }
        return failMsg;
    }

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title={`Redemption Fail ${Util.isLog && recordInfo.failState}`}
            onClose={onClose}
            buttons={[
                { label: "Contact Us", onClick: onBtnClick, style: "blueBtn" },
            ]}
        >
            <ScrollableContainer>
                <div className={styles.dialogContent} style={{
                    maxHeight: "6rem",
                }}>
                    <p>
                        {getFailMsg()}
                    </p>
                </div>
            </ScrollableContainer>
        </SDialogFC>
    );
};
